import { isAllowed } from '../cmp/utils';

export const createStorageRepository = type => ({
  get(key, fallbackValue = null) {
    try {
      return isAllowed(type, key)
        ? JSON.parse(window[type].getItem(key))
        : fallbackValue;
    } catch (error) {
      return null;
    }
  },
  set(key, value) {
    if (isAllowed(type, key)) {
      window[type].setItem(key, JSON.stringify(value));
    }
  },

  delete(key) {
    window[type].removeItem(key);
  },

  clear() {
    window[type].clear();
  },

  forEach(callback) {
    Object.keys(window[type]).forEach(callback);
  },
});
